import { useState } from "react";
import { Input } from "../Input/Input";
import { Dropdown } from "../Dropdown/Dropdown";
import { Button } from "../buttons/Button/Button";
import { CheckForm } from "../CheckForm/CheckForm";
import { Link } from "../Link/Link";
import { senderCategory } from "./assets";
// import { ThankYouPage } from "./ThankYouPage";
import "./form.css";

export const AnonymousFeedbackForm = () => {
  const [agreed, setAgreed] = useState({ terms: true, anonymous: true });
  const [anonymously, setAnonymously] = useState(false);

  const onAgreedTerms = (value) => {
    setAgreed(value);
    setAgreed({ terms: value, anonymous: agreed.anonymous });
  };

  const onAgreedAnonymous = (value) => {
    setAgreed({ terms: agreed.terms, anonymous: value });
  };

  const handleInputChange = (e) => {};

  const onSubmitForm = (e) => {
    e.preventDefault();
  };

  const onAnonymously = (value) => {
    setAnonymously(value);
  };

  return (
      <form onSubmit={onSubmitForm} className="form">
          <div className="content-form-wrapper">
              <div className="form-dropdown">
                  <label>
                      <span className="body3">SELECT A SENDER CATEGORY*</span>
                      <Dropdown options={senderCategory} />
                  </label>
              </div>
              <div className="inputs-line">
                  <label>
                      <span className="body3">SUBJECT OF THE MESSAGE*</span>
                      <Input
                          type="text"
                          placeholder="Please enter the subject of the message"
                          name="message-subject"
                          onChange={handleInputChange}
                      />
                  </label>
              </div>
              <label>
                  <span className="body3">YOUR MESSAGE*</span>
                  <textarea className="textarea" placeholder="Please enter your message" name="message"></textarea>
              </label>
              <div className={`checkbox-wrapper margin-bottom ${anonymously && 'is-anonymously'}`}>
                  <CheckForm onClick={onAnonymously}>
                      <span>I want to send a message anonymously</span>
                  </CheckForm>
              </div>
              <div className={`not-anonym-wrapper ${anonymously && 'anonym-wrapper'}`}>
                  <div className="inputs-line">
                      <label>
                          <span className="body3">COUNTRY</span>
                          <Input type="text" placeholder="Your country" name="country" onChange={handleInputChange} />
                      </label>
                      <label>
                          <span className="body3">REGION</span>
                          <Input type="text" placeholder="Your region" name="region" onChange={handleInputChange} />
                      </label>
                  </div>
                  <div className="inputs-line">
                      <label>
                          <span className="body3">NAME</span>
                          <Input type="text" placeholder="Your name" name="name" onChange={handleInputChange} />
                      </label>
                      <label>
                          <span className="body3">PHONE</span>
                          <Input type="tel" placeholder="Your phone number" name="phone" onChange={handleInputChange} />
                      </label>
                  </div>
                  <div className="inputs-line">
                      <label>
                          <span className="body3">E-MAIL</span>
                          <Input type="email" placeholder="E-mail" name="email" onChange={handleInputChange} />
                      </label>
                      <label>
                          <span className="body3">POSTAL ADDRESS</span>
                          <Input
                              type="text"
                              placeholder="Your postal address"
                              name="postal-address"
                              onChange={handleInputChange}
                          />
                      </label>
                  </div>
              </div>
              <div className="submit-wrapper">
                  <div className="checkbox-wrapper">
                      <div className="anonymous-checkbox-wrapper">
                          <CheckForm onClick={onAgreedTerms} checked={true}>
                              <span>I agree to the</span> <Link href="/#">Terms of Use</Link>
                              <span> and</span> <Link href="/#">Privacy Policy</Link>
                          </CheckForm>
                          <CheckForm onClick={onAgreedAnonymous} checked={true}>
                              <span>I agree to the</span> <Link href="/#">Anonymous reporting policy</Link>
                          </CheckForm>
                      </div>
                  </div>
                  <div className="submit-button">
                      <Button type={`${(!agreed.terms || !agreed.anonymous) && 'disabled'} submit`}>SUBMIT</Button>
                  </div>
              </div>
          </div>
          {/* <ThankYouPage /> */}
      </form>
  );
};
